import React, { useState, useEffect } from 'react';
import {Button,Container,Header,Grid} from 'semantic-ui-react'
import SelectSize from './SelectSize'
import {useHistory} from 'react-router-dom'

function SelectUserSize(props) {

  const {kunden,setKunden,paketUID,paketeDB,dienst, scanNo,setScanNo}=props
  const [paket,setPaket]=useState({Paketnummer:null })
  const history=useHistory()

  useEffect(()=>{
      const getPaket= async ()=>
      {
          const myPaket=await paketeDB.get(paketUID)
          setPaket(myPaket)
      }

      if(paketUID)
        getPaket()

  },[paketUID])

 
  const click= async (e,{name})=>
  {
    if(name==='incorrect')
    {
      history.push(`/register/paket/${dienst}/correct`)
    }
    else if(name==='wiederholen')
    {
      await paketeDB.delete(paketUID)
      setKunden([])
      history.push(`/register/paket/${dienst}/scan`)  
    }
    else
    {
      if(kunden[0].Modus==='manuell')
      {
         paketeDB.update(paketUID,{Size:  (dienst==='Brief' || dienst==='Brief2' ? 'Brief' : 'Paket'), Status:'registriert', Kunde: kunden[0].UID})
      }
      else
      {
         paketeDB.update(paketUID,{Size:name,Status:'registriert', Kunde: kunden[0].UID})
      }
      setKunden([])
      history.push(`/register/paket/${dienst}/scan`)
    }

  }

  



  return (
  <>
    <Container >
      <Header as="h2" textAlign='center' style={{'margin-top':'3rem'}}>
      Paketnummer:  {paket.Paketnummer}
      </Header>
      <Header as="h2" textAlign='center' style={{'margin-top':'3rem'}}>
      Kunde:  {kunden.length ? `${kunden[0].Vorname} ${kunden[0].Nachname}` : '-'} 
      </Header>
      <Grid>
        <Grid.Column key={1} width={8}>
          <Button size='big' name='incorrect' onClick={click} content='anderer Kunde' color='blue'/>
        </Grid.Column>
        <Grid.Column key={1} width={8}>
          <Button size='big' name='wiederholen' onClick={click} content='Barcode Scan wiederholen' color='red'/>
        </Grid.Column>
      </Grid>

    <SelectSize
        kunde={kunden[0]}
        click={click}
    />

    </Container>
    </>

  )
}




export default  SelectUserSize
